if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyATCBar extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          variantIdSelect: '[name="id"]'
        }
      }

      connectedCallback() {
        this.container = this.closest(".sticky_pro_page");

        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");

        if (this.mainProduct) {
          this.productFormActions = this.mainProduct.querySelector("product-form");
        } else {
          return;
        }

        this.variantData = this.getVariantData();

        this.init();

        this.handleDynamicSpacing();

        this.select.addEventListener("change", (e) => {
          e.preventDefault();
          if (this.isUpdating) return;

          this.isUpdating = true;

          window.__preventScrollTrigger = '0';
          setTimeout(() => {
            window.__preventScrollTrigger = '1';
          }, 2000);

          this.mainVariantSelects = this.mainProduct && this.mainProduct.querySelector("variant-selects");

          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll("select, fieldset"), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];

              switch (element.tagName) {
                case "SELECT":
                  element.querySelectorAll("option").forEach(option => option.removeAttribute("selected"));
                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) selectedOption.setAttribute("selected", "selected");
                  break;

                case "FIELDSET":
                  Array.from(element.querySelectorAll("input")).forEach(radio => {
                    radio.value === variantOptionVal && (radio.checked = true);
                  });
                  break;
              }
            });

            this.mainVariantSelects.dispatchEvent(new Event("change"));
            this.isUpdating = false;
          } else {
            this.isUpdating = false;
          }

          this.updateProductInfo();
          this.updateSubmitButton(true, "");

          if (this.currentVariant) {
            this.updateSubmitButton(!this.currentVariant.available, window.variantStrings.soldOut);
          } else {
            this.updateSubmitButton(true, "");
          }
        });
      }

      handleDynamicSpacing() {
        const stickyBar = this.container;
        if (!stickyBar) return;

        const updateSpacing = () => {
          const isActive = stickyBar.classList.contains('sticky_padd');
          const height = stickyBar.offsetHeight;

          if (isActive && height > 0) {
            document.body.style.paddingBottom = height + 'px';
          } else {
            document.body.style.paddingBottom = '0px';
          }

          stickyBar.style.visibility = isActive ? 'visible' : 'hidden';
        };

        updateSpacing();

        const observer = new MutationObserver(updateSpacing);
        observer.observe(stickyBar, {
          attributes: true,
          attributeFilter: ['class']
        });

        window.addEventListener('resize', updateSpacing);

        const resizeObserver = new ResizeObserver(updateSpacing);
        resizeObserver.observe(stickyBar);
      }

      // 🔥 FINAL PERFECT LOGIC (LIKE LYRA)
      init() {
        this.productSection = document.querySelector("product-info[id^='MainProduct']");

        if (!this.productSection) {
          this.container.classList.add("sticky_padd");
          document.body.classList.add("sticky_padd_show");
          return;
        }

        const checkVisibility = () => {
          const rect = this.productSection.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          // ✅ show exactly when section ends in viewport
          const isPastMainProduct = rect.bottom <= viewportHeight;

          if (isPastMainProduct) {
            this.container.classList.add("sticky_padd");
            document.body.classList.add("sticky_padd_show");
          } else {
            this.container.classList.remove("sticky_padd");
            document.body.classList.remove("sticky_padd_show");
          }
        };

        // 🔥 smooth + performant scroll
        let ticking = false;
        const onScroll = () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              checkVisibility();
              ticking = false;
            });
            ticking = true;
          }
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", checkVisibility);

        checkVisibility();

        this.syncWithMainProductForm();
      }

      getVariantData() {
        return this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      }

      updateSubmitButton(disable = true, text) {
        const productForm = this.querySelector("form");
        if (!productForm) return;

        const submitButton = productForm.querySelector('[name="add"]');
        if (!submitButton) return;

        const submitButtonText = submitButton.querySelector("span");

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updateProductInfo() {
        fetch(`${this.getAttribute("data-url")}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then(response => response.text())
          .then(responseText => {
            const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");

            const quantity = this.querySelector(`#Quantity-Form-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#Quantity-Form-${this.sectionId}`);
            if (quantity && newQuantity) quantity.innerHTML = newQuantity.innerHTML;

            const price = this.querySelector(`#Price-${this.sectionId}`);
            const newPrice = parsedHTML.querySelector(`#Price-${this.sectionId}`);
            if (price && newPrice) price.innerHTML = newPrice.innerHTML;
          })
          .catch(error => console.error(error));
      }

      syncWithMainProductForm() {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.mainProduct.dataset.sectionId) {
            const variant = event.data.variant;
            const variantInput = this.querySelector('[name="id"]');

            this.currentVariant = variant;
            variantInput.value = variant.id;

            this.updateProductInfo();
            this.updateSubmitButton(true, "");

            if (this.currentVariant) {
              this.updateSubmitButton(!this.currentVariant.available, window.variantStrings.soldOut);
            } else {
              this.updateSubmitButton(true, "");
            }
          }
        });
      }

      get select() {
        return this.querySelector("select");
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}